import { render, staticRenderFns } from "./BoardListNewsLayout.vue?vue&type=template&id=7902b056&scoped=true&"
import script from "./BoardListNewsLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListNewsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7902b056",
  null
  
)

export default component.exports